/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component } from 'react';
import { fetch }            from '@fyresite/fetch';
import validator            from 'validator';

import TextInput       from '@fyresite/react-textinput';
import Button          from '../../../components/Button'
class SendPasswordReset extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: {
        value: '',
        valid: '',
      }
    };

    this.handleSubmit      = this.handleSubmit.bind(this);
  }

  onChange(field, e, inputState) {
    let state = Object.assign({}, this.state);

		state[field] = Object.assign({}, state[field], inputState);

    this.setState((prevState, props) => {
      return state;
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (!this.state.email.valid) {
      Materialize.toast('Please enter a valid email.', 4000, 'red');
    } else {


      let response = await fetch(`/api/v1/user/passwordReset/create/${this.state.email.value}`,{
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        credentials: process.env.NODE_ENV === 'production' ? 'same-origin' : 'include'
      }).then(res => {
        return res;
      }).catch(err => {
        Materialize.toast('There was an error sending the password reset email.', 4000, 'red');
        return {status: 501, error: err}
      });

      if(response.status !== 501){
        let json = await response.json()
        if (json.code === 200) {
          Materialize.toast(`Email reset has been sent to ${this.state.email.value}`, 4000, 'green');
          this.props.history.push('/')
        } else {
          Materialize.toast(json.message, 4000, 'red');
        }
      }
    }
  }

  render() {
    return (
      <div className="send-password-reset card-wrapper">
        <div className="card-container">

          <div className="reset-card card z-depth-5" ref="login-card">
            <div className="card-content">
              <span className="card-title">AlphaScrip Web Portal</span>

              <form onSubmit={this.handleSubmit.bind(this)} className="left-align" noValidate>
                <TextInput
                  ref={input => this.email = input}
                  className=""
                  inputClassName=""
                  label="Email"
                  type="email"
                  onChange={this.onChange.bind(this, 'email')}
                  value={this.state.email.value}
                  valid={this.state.email.valid}
                  validator={val => { return validator.isEmail(val) }}
                  error="Please enter a valid email" />
                

                <Button
                  color={'red'}
                  flat={false}
                  onClick={this.handleSubmit.bind(this)}
                  z-depth={1}>
                  {"Submit"}
                </Button>

                <Button
                  flat={true}
                  onClick={e => this.props.history.push('/')}
                  z-depth={1}>
                  {"Back"}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SendPasswordReset;



// WEBPACK FOOTER //
// ./src/pages/Home/SendPasswordReset/SendPasswordReset.js